import { useGetIntroductionsMadeByMe } from '@queries/introductions';
import { useAuthStore } from '@sunrise-ui/primitives';
import { findIntro } from '@utils/introductions';

export default function useIntroMadeByMeById({
  introId,
}: {
  introId?: string;
}) {
  if (!introId)
    return { isLoading: false, requestor: undefined, acceptor: undefined };

  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingPendingIntros, data: pendingIntros } =
    useGetIntroductionsMadeByMe({
      userId: currentUserId,
      state: 'pending',
    });
  const { isLoading: isLoadingAcceptedIntros, data: acceptedIntros } =
    useGetIntroductionsMadeByMe({
      userId: currentUserId,
      state: 'accepted',
    });
  const { isLoading: isLoadingDeniedIntros, data: deniedIntros } =
    useGetIntroductionsMadeByMe({
      userId: currentUserId,
      state: 'denied',
    });

  const isLoading =
    isLoadingPendingIntros || isLoadingAcceptedIntros || isLoadingDeniedIntros;
  const introductions = [
    ...(pendingIntros ?? []),
    ...(acceptedIntros ?? []),
    ...(deniedIntros ?? []),
  ];

  const intro = findIntro(introductions, introId);
  const requestor = intro?.introduction.find(
    (iHalf) => iHalf.introduced_to.intro_role === 'requestor',
  );
  const acceptor = intro?.introduction.find(
    (iHalf) => iHalf.introduced_to.intro_role === 'acceptor',
  );

  return { isLoading, requestor, acceptor };
}
